import React from 'react';
import { Check } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
interface ESIMConfirmationScreenProps {
  onHome: () => void;
}
export function ESIMConfirmationScreen({
  onHome
}: ESIMConfirmationScreenProps) {
  return <div className="min-h-screen bg-white flex flex-col items-center justify-center p-6 text-center" data-id="element-156">
      <div className="w-16 h-16 bg-green-100 text-green-600 rounded-full flex items-center justify-center mb-6" data-id="element-157">
        <Check size={32} strokeWidth={3} data-id="element-158" />
      </div>

      <h1 className="text-2xl font-bold text-[#003366] mb-2" data-id="element-159">eSIM prête !</h1>
      <p className="text-gray-500 mb-8 max-w-xs mx-auto" data-id="element-160">
        Scannez le code QR ci-dessous pour installer votre forfait data eSIM.
      </p>

      <Card className="p-6 mb-8 bg-white shadow-lg border border-gray-100" data-id="element-161">
        <div className="w-48 h-48 bg-gray-900 mx-auto mb-4 rounded-lg flex items-center justify-center text-white/50 text-xs" data-id="element-162">
          [CODE QR]
        </div>
        <p className="text-xs text-gray-400" data-id="element-163">
          Scannez avec l'appareil photo de votre téléphone
        </p>
      </Card>

      <div className="w-full max-w-sm text-left mb-8" data-id="element-164">
        <h3 className="font-bold text-gray-900 mb-3" data-id="element-165">Comment installer :</h3>
        <ol className="list-decimal list-inside space-y-2 text-sm text-gray-600" data-id="element-166">
          <li data-id="element-167">
            Allez dans <strong data-id="element-168">Réglages</strong> →{' '}
            <strong data-id="element-169">Données cellulaires</strong>
          </li>
          <li data-id="element-170">
            Appuyez sur <strong data-id="element-171">Ajouter eSIM</strong>
          </li>
          <li data-id="element-172">Scannez le code QR ci-dessus</li>
          <li data-id="element-173">Suivez les instructions à l'écran</li>
        </ol>
      </div>

      <div className="w-full max-w-sm space-y-3" data-id="element-174">
        <Button fullWidth onClick={onHome} data-id="element-175">
          Terminé
        </Button>
        <Button fullWidth variant="ghost" className="text-sm" data-id="element-176">
          Besoin d'aide ?
        </Button>
      </div>
    </div>;
}